import { render, staticRenderFns } from "./FormCampaignPanel.vue?vue&type=template&id=1f9070bc&scoped=true"
import script from "./FormCampaignPanel.vue?vue&type=script&lang=js"
export * from "./FormCampaignPanel.vue?vue&type=script&lang=js"
import style0 from "./FormCampaignPanel.vue?vue&type=style&index=0&id=1f9070bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f9070bc",
  null
  
)

export default component.exports